
import { computed, defineComponent, ref } from "vue";
import HelpCenter from "./help-center.vue";
import router from "../../router";
import Footer from "@/app/ui/components/footer/index.vue";
import { AuthController } from "../../controllers/AuthController";
import { BadgeResponse } from "@/domain/entities/MainApp";
import { SetupPasswordValidationApiRequest } from "@/data/payload/api/AuthRequest";
import { createI18n } from "vue-i18n";
import en from "@/i18n/locales/en";
import id from "@/i18n/locales/id";
import my from "@/i18n/locales/my";

export default defineComponent({
  name: "ErrorToken",
  components: { HelpCenter, Footer },
  setup() {
    /** ========= DATA ========= */
    const i18nInstance = createI18n({
      legacy: false,
      locale: router.currentRoute.value.query?.is_en === "true" ? "my" : "id",
      fallbackLocale: "id",
      globalInjection: false,
      messages: {
        en,
        id,
        my
      }
    });
    const t = i18nInstance.global.t;

    const email = ref((router.currentRoute.value.query?.email as string) || "");
    const token = ref((router.currentRoute.value.query?.token as string) || "");

    /** ========= FUNCTION ========= */
    const toLogin = () => router.replace({ name: "login" });
    const onResendLink = () => {
      AuthController.resendSetupPasswordLink(
        new SetupPasswordValidationApiRequest({
          token: token.value,
          email: email.value
        })
      );
    };

    /** ========= COMPUTED ========= */
    const tokenResponseData = computed(() => {
      const response = AuthController.tokenResponse;

      const defaultData = new BadgeResponse({
        textSuccess: t("setupPassword.loginGenesis"),
        onSubmit: toLogin
      });

      if (response.isExpired) {
        return new BadgeResponse({
          title: t("setupPassword.expired.title"),
          message: t("setupPassword.expired.description"),
          textSuccess: t("setupPassword.expired.requestNewUrl"),
          onSubmit: onResendLink
        });
      }

      if (response.isUsed) {
        return new BadgeResponse({
          ...defaultData,
          title: t("setupPassword.urlUsed"),
          message: t("setupPassword.messageUsed")
        });
      }

      if (response.isInvalid) {
        return new BadgeResponse({
          ...defaultData,
          title: t("setupPassword.urlInvalid"),
          message: t("setupPassword.messageInvalid")
        });
      }

      return new BadgeResponse();
    });

    /** ========= RETURN ========= */
    return {
      tokenResponseData,
      t
    };
  }
});
